/**
 * Returns a CDN URL for the default placeholder profile image corresponding to
 * the given user ID. The same algorithm is used in the Influenster mobile app.
 *
 * There are 10 distinct placeholder images (indices 0–9), selected by
 * `id % 10`. When `id` is `undefined` or `0` the first image (index 0) is used.
 *
 * @example
 * placeholderUrlForId(42)
 * // "https://cdn.influenster.com/static/img/default/newdefault2/profiledefault-2.png"
 */
export function placeholderUrlForId(id?: number): string {
  const iv = (id || 0) % 10;
  return `https://cdn.influenster.com/static/img/default/newdefault2/profiledefault-${iv}.png`;
}
